"use client";

import dynamic from "next/dynamic";
import { useEffect, type ReactNode } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { captureUtms } from "@/utils/utm";
import patchDomReconciliation from "@/utils/patchDomReconciliation";
import { DEFAULT_LOCALE } from "@/utils/localeConstants";
import {
  ReadableCopy,
  ReadableValue,
  readableFallback,
} from "@/components/readable";

patchDomReconciliation();

const PrimaryNavigation = dynamic(
  () => import("@/templates/PrimaryNavigation"),
  { ssr: false, loading: readableFallback() },
);

const Footer = dynamic(() => import("@/templates/Footer"), {
  ssr: false,
  loading: readableFallback(),
});

interface ClientLayoutProps {
  navData?: any;
  footerData?: any;
  locale?: string;
  children: ReactNode;
}

export default function ClientLayout({
  navData,
  footerData,
  locale,
  children,
}: ClientLayoutProps) {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    captureUtms();
  }, [pathname, searchParams]);

  const readableLocale = locale ?? DEFAULT_LOCALE;

  return (
    <>
      <ReadableCopy
        copy={
          <nav>
            <ReadableValue value={navData} locale={readableLocale} />
          </nav>
        }
      >
        <PrimaryNavigation data={navData} locale={locale} />
      </ReadableCopy>
      {children}
      <ReadableCopy
        copy={
          <footer>
            <ReadableValue value={footerData} locale={readableLocale} />
          </footer>
        }
      >
        <Footer data={footerData} locale={locale} />
      </ReadableCopy>
    </>
  );
}
